var map = {
	"./add.svg": 7025,
	"./ask.svg": 8907,
	"./askpaper.svg": 3036,
	"./banner.svg": 8970,
	"./book.svg": 3535,
	"./catalog.svg": 2525,
	"./clock.svg": 8578,
	"./comment.svg": 6271,
	"./course.svg": 607,
	"./dataquery.svg": 6860,
	"./down.svg": 3548,
	"./excel.svg": 4681,
	"./feedback.svg": 5461,
	"./help.svg": 5153,
	"./home.svg": 6613,
	"./id.svg": 8967,
	"./idea.svg": 8809,
	"./img.svg": 2829,
	"./kpi.svg": 1034,
	"./learn.svg": 4018,
	"./metting.svg": 6550,
	"./my.svg": 8630,
	"./org.svg": 3578,
	"./plan.svg": 5601,
	"./poster.svg": 1943,
	"./press.svg": 9061,
	"./raise.svg": 2832,
	"./ring.svg": 8006,
	"./run.svg": 8559,
	"./setting.svg": 1231,
	"./sms.svg": 6519,
	"./station.svg": 5884,
	"./tag.svg": 7648,
	"./task.svg": 7919,
	"./up.svg": 871,
	"./upload.svg": 2763,
	"./user.svg": 6606,
	"./users.svg": 9824,
	"./walk.svg": 8027,
	"./word.svg": 6320,
	"./write.svg": 8765,
	"./write2.svg": 4917
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;